/** True while the element's whole height fits the window above the sticky bar: the panel sticks only then; a taller panel scrolls away with the page, never inside its own column. The room the bar takes is measured from a probe styled with the bar's own reserve token. */
import { useEffect, useState, type RefObject } from "react";

const FALLBACK_RESERVE_PX = 140; // used only where nothing is laid out (no layout engine)

export function useStickyWhenFits(ref: RefObject<HTMLElement | null>): boolean {
  const [fits, setFits] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (el === null) return;
    const probe = document.createElement("div");
    probe.setAttribute("aria-hidden", "true");
    probe.setAttribute("data-gx-reserve-probe", "");
    probe.style.cssText = "position:absolute;visibility:hidden;pointer-events:none;width:0;height:var(--gx-bar-reserve)";
    document.body.appendChild(probe);
    const measure = () => {
      const reservePx = probe.offsetHeight > 0 ? probe.offsetHeight : FALLBACK_RESERVE_PX;
      setFits(el.offsetHeight <= window.innerHeight - reservePx);
    };
    measure();
    const observer = typeof ResizeObserver === "undefined" ? null : new ResizeObserver(measure);
    observer?.observe(el);
    const dock = document.querySelector(".gx-decide-dock");
    if (dock !== null) observer?.observe(dock);
    observer?.observe(probe);
    window.addEventListener("resize", measure);
    return () => { observer?.disconnect(); window.removeEventListener("resize", measure); probe.remove(); };
  }, [ref]);
  return fits;
}
